import * as yup from 'yup';

import { reportToDate } from '../../../../../../../constants/validation';
import { FORM_INPUT_ERROR_MSGS } from '../../../../../../../constants/errors';

export const filtersValidationSchema = yup.object().shape({
  from: yup
    .date()
    .required(FORM_INPUT_ERROR_MSGS.REQUIRED('starting date'))
    .typeError(FORM_INPUT_ERROR_MSGS.INVALID_FORMAT('starting date')),
  to: reportToDate
});
